import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TiersRoutingModule } from './tiers-routing.module';
import { TiersComponent } from './tiers.component';
import { TiersService } from './services/tiers.service';
import { TierDetailComponent } from './tier-detail/tier-detail.component';
import { DataTableModule } from 'primeng/components/datatable/datatable';
import { SharedModule } from 'primeng/components/common/shared';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/components/calendar/calendar';
import { ConfirmDialogModule } from 'primeng/components/confirmdialog/confirmdialog';
import { ConfirmationService } from 'primeng/components/common/api';
import { GrowlModule } from 'primeng/primeng';

@NgModule({
	imports: [
		CommonModule,
		TiersRoutingModule,
		DataTableModule,
		SharedModule,
		FormsModule,
		CalendarModule,
		ConfirmDialogModule,
		GrowlModule
	],
	exports: [
		TiersComponent,
		TiersRoutingModule,
	],
	providers: [TiersService, ConfirmationService],
	declarations: [TiersComponent, TierDetailComponent]
})
export class TiersModule
{
}



// WEBPACK FOOTER //
// ./src/app/tiers/tiers.module.ts